module.exports = __webpack_public_path__ + "static/media/slab.b27dc515.svg";